import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { getTotalUnreadCount } from 'app/utils/chat/unreadUtils';
import { manageFavicon } from 'app/utils/faviconBadge';

const updateFavicon = manageFavicon();

/**
 * Renders nothing; mirrors the header bell unread count onto the favicon.
 */
class FaviconBadge extends PureComponent {
    static propTypes = {
        subscriptions: PropTypes.array,
        profile: PropTypes.object,
    };

    constructor(props) {
        super(props);
        const { permissions, isAdmin } = props.profile || {};
        const permissionsSet = new Set(permissions || []);
        this.canSeeAlive = isAdmin || permissionsSet.has('alive.alive');
    }

    componentDidMount() {
        this.updateBadge();
    }

    componentDidUpdate() {
        this.updateBadge();
    }

    updateBadge() {
        if (!this.canSeeAlive) return;
        updateFavicon(getTotalUnreadCount(this.props.subscriptions));
    }

    render() {
        return null;
    }
}

const mapStateToProps = state => ({
    subscriptions: state.chat.subscriptions.data,
    profile: state.user.profile,
});

export default connect(mapStateToProps)(FaviconBadge);
